export interface IRsdKraj {
  ZkratkaCSU: string;
  Nazev: string;
}
